document.addEventListener("turbolinks:load", () => {
  const first_channel = document.getElementById('youtube_master_setting_master_setting_channels_attributes_0_channel_id');
  const addButton = document.getElementById("add_main_serie_ips_channels");

  if (addButton) {
    addButton.addEventListener("click", (e) => {
      e.preventDefault();
      const mainSerieIpSelect = document.getElementById("main_serie_ip_select").tomselect;
      const selectedIds = mainSerieIpSelect.getValue();
      console.log(selectedIds);
      if (selectedIds.length > 0) {
        const selectedOptions = Object.fromEntries(
          Object.entries(mainSerieIpSelect.options).filter(([key, value]) => selectedIds.includes(key))
        );
        const allChannelIds = Array.from(
          new Set(
            Object.values(selectedOptions)
              .flatMap(option => option.channel_ids.map(String))
          )
        );
        const cocoonContainer = document.querySelector(".cocoon.channels");

        allChannelIds.forEach(channelId => {
          if (first_channel.value == '') {
            first_channel.value = channelId;
            first_channel.dispatchEvent(new Event('change'));
          } else {
            const addButton = document.querySelector(".add_fields");

            addButton.click();
            const lastItem = cocoonContainer.querySelector(".nested-fields.channels:last-child");
            const selectChannel = lastItem.querySelector('[id$="_channel_id"]');
            if (selectChannel) { selectChannel.value = channelId; selectChannel.dispatchEvent(new Event('change')); }
          }
        });
      }
    });
  }
});
